import styled from "styled-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";

export const Container = styled.div`
    position: absolute;
    right: 12px;
    top: 12px;
`;

export const StyledIconButton = styled(IconButton)`
    height: 40px;
    width: 40px;

    svg path {
        fill: ${colorsPalettes.carbon[400]};
    }
`;
